module.exports = __webpack_public_path__ + "static/media/softwareone.786b56dc.png";